<template>
  <app-dropdown class="more-actions">
    <svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15.5" cy="1.5" r="1.5" fill="white"/>
      <circle cx="8.5" cy="1.5" r="1.5" fill="white"/>
      <circle cx="1.5" cy="1.5" r="1.5" fill="white"/>
    </svg>
    <template slot="drop">
      <!-- TODO добавить перевод -->
      <app-dropdown-item icon="edit" @click="$emit('edit')">
        Edit
      </app-dropdown-item>
      <app-dropdown-item icon="delete" @click="$emit('remove')">
        Delete
      </app-dropdown-item>
    </template>
  </app-dropdown>
</template>

<script>
export default {

}
</script>

<style>

</style>